/**
 * Fail-closed env validation for sentinel-web.
 * Throws before React mounts if required vars are absent.
 * C-11 Production Readiness — config safety.
 *
 * Resolution and rendering are delegated to {@link @rtvloco/platform/env}
 * so this file does not read `window.__ENV__` or `import.meta.env.VITE_*`
 * directly (canonical pattern — see CLAUDE.md memory `feedback_runtime_config_via_getenv_only`).
 */

import {
  isMockMode,
  validateConfig,
  showBootstrapError,
  type ConfigRequirement,
} from '@rtvloco/platform/env';

const REQUIRED: ReadonlyArray<ConfigRequirement> = [
  { key: 'VITE_GRAPHQL_URL', description: 'GraphQL HTTP endpoint (https://...)' },
  { key: 'VITE_GRAPHQL_WS_URL', description: 'GraphQL WebSocket endpoint (wss://...)' },
];

export function validateEnv(): void {
  if (isMockMode) return;

  const errors = validateConfig([...REQUIRED]);
  if (errors.length > 0) {
    showBootstrapError(errors, 'sentinel-web');
    throw new Error(
      `[sentinel-web] Missing required environment variables: ${errors
        .map(e => e.canonicalKey)
        .join(', ')}`,
    );
  }
}
